interface ModeSelectorProps {
  currentMode: string;
  onModeChange: (mode: string) => void;
}

const modes = [
  { id: 'text2img', labelKey: 'mode_text2img' },
  { id: 'img2img', labelKey: 'mode_img2img' },
  { id: 'edit', labelKey: 'mode_edit' },
  { id: 'restore', labelKey: 'mode_restore' },
  { id: 'tryon', labelKey: 'mode_tryon' },
];

export default function ModeSelector({ currentMode, onModeChange }: ModeSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="-mx-1 overflow-x-auto ios-scroll px-1">
      <div className="flex w-full min-w-max items-center justify-between gap-1.5">
      {modes.map((mode) => {
        const active = mode.id === currentMode;
        return (
          <button
            key={mode.id}
            onClick={() => onModeChange(mode.id)}
            aria-pressed={active}
            className={`flex-none text-center px-3 py-1.5 rounded-full text-[13px] font-medium cursor-pointer whitespace-nowrap transition-all duration-200 active:scale-95 ${
              active
                ? 'text-white shadow-sm'
                : 'text-gray-400 hover:text-gray-500'
            }`}
            style={
              active
                ? { background: 'linear-gradient(135deg, #FF6B9D, #A855F7)' }
                : { border: '1px solid rgba(0,0,0,0.05)' }
            }
          >
            <span>{t(mode.labelKey)}</span>
          </button>
        );
      })}
      </div>
    </div>
  );
}
